import { Component } from '@angular/core';

@Component({
  selector: 'axle-profile-container',
  standalone: true,
  imports: [],
  templateUrl: './profile-container.component.html'
})
export class AxleProfileContainerComponent {}
